// extracted by mini-css-extract-plugin
export default {"container":"TabsNavigation_container__9hMyO","tab":"TabsNavigation_tab__oi79-","tabSelected":"TabsNavigation_tabSelected__wHRW4"};